import { GeneralReportMessage } from '../../../../types/GeneralReportMessage';
import { ProductContext } from '../../../../types/ProductContext';
import { SpecificReportMessage } from '../../../../types/SpecificReportMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';
import { nonEmpty } from '../paramUtils';

interface GetReportParams {
    from: number;
    to: number;
    customerIds?: string[];
    supplierIds?: string[];
}

export const getGeneralReport = async (params: GetReportParams): Promise<GeneralReportMessage> => {
    const response = await authorizedAxiosInstance.get<GeneralReportMessage>(`/v1/report`, {
        params: {
            from: params.from,
            to: params.to,
            types: ProductContext.LUBES,
            customerIds: nonEmpty(params.customerIds),
            supplierIds: nonEmpty(params.supplierIds),
        },
    });

    return response.data;
};

export const getProductGroupReport = async (params: GetReportParams): Promise<SpecificReportMessage> => {
    const response = await authorizedAxiosInstance.get<SpecificReportMessage>(`/v1/report/productgroup`, {
        params: {
            from: params.from,
            to: params.to,
            types: ProductContext.LUBES,
            customerIds: nonEmpty(params.customerIds),
            supplierIds: nonEmpty(params.supplierIds),
        },
    });

    return response.data;
};
